export default "__VITE_ASSET__BIrHy5N$__";